import * as S from "./TabContent.style";

interface TabContentProps {
  nav?: boolean;
  padding?: boolean;
  tabList?: React.ReactNode;
  children?: React.ReactNode;
}

export const TabContent = ({
  nav = true,
  padding = true,
  tabList,
  children,
}: TabContentProps) => {
  return (
    <S.TabContent $nav={nav}>
      <S.TabListBox>{tabList}</S.TabListBox>
      <S.TabItemContent $nav={nav} $padding={padding}>
        {children}
      </S.TabItemContent>
    </S.TabContent>
  );
};
